/* RESPONSIBLE TEAM: team-fin-qa */
import Model, { attr } from '@ember-data/model';

export default class AiTopic extends Model {
  @attr('string') declare name: string;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'qa-monitor/ai-topic': AiTopic;
  }
}
